$mol_float $mol_view
	style *
		^
		minHeight \auto
